import { Allergens } from './menuCard';
import AllergensModal from './modal';

export { Allergens as AllergensMenuCard, AllergensModal };
